import * as React from "react";
import NoteLogCard from "./NoteLogCard";
import { Stack } from "@mui/material";

export default function NoteLogList({ log }) {
  return (
    log?.length > 0 && (
      <Stack spacing={2}>
        {log.map((props) => (
          <NoteLogCard key={props.id} {...props} />
        ))}
      </Stack>
    )
  );
}
